//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
	
	props: ["list","get","xiang","outtime"],
	methods:{
		show(){
			this.$store.state.isshow = false
		}
	},
	computed:{
		isShow(){
			console.log("1");
			return this.$store.state.isshow;
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/xstom.vue